import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Snackbar} from "../../../../../util/snackbar";
import {ErrorUtil} from "../../../../../util/error";
import {PropertyProvider} from "../../../../../providers/company/property/property";
import {ProductProvider} from "../../../../../providers/product/product";
import {StockProvider} from "../../../../../providers/stock/stock";
import {DateUtil} from "../../../../../util/dateUtil";
import {ParticipantProvider} from "../../../../../providers/participant/participant";
import {BelongingsProvider} from "../../../../../providers/belongings/belongings";
import Swal from "sweetalert2";
import {HttpErrorResponse} from "@angular/common/http";
import * as moment from "moment";
import { Observable, Subject } from 'rxjs';
import { ReceiptProvider } from 'src/providers/receipt/receipt';
import { map, startWith, takeUntil } from 'rxjs/operators';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { AdicionarArquivosComponent } from 'src/app/routes/cadastros/enviar-arquivos/adicionar-arquivos/adicionar-arquivos.component';

@Component({
  selector: 'app-cadastro-bens',
  templateUrl: './cadastro-bens.component.html',
  styleUrls: ['./cadastro-bens.component.scss']
})
export class CadastroBensComponent implements OnInit {

  public description: FormControl;
  public code: FormControl;
  public years: FormGroup[] = [];
  public selectable = true;
  public receipts: any = [];
  public allReceipts: any[];
  public filteredReceipts: any[]
  public removable = true;
  public receiptCtrl = new FormControl();
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesHistoric: number[] = [ENTER, COMMA];
  protected _onDestroy = new Subject<void>();
  public observation = new FormControl();
  public filteredReceipt;
  public carregando: boolean = false;
  public enviando: boolean = false;
  public enviado: boolean = false;
  public edit: boolean = false;
  public exist: any;
  public allYears: any[] = [];
  @ViewChild('receiptInput', {static: false}) receiptInput: ElementRef<HTMLInputElement>;

  constructor(public activeModal: NgbActiveModal,
              public fb: FormBuilder,
              public snackBar: Snackbar,
              public erroUtil: ErrorUtil,
              public propertyProvider: PropertyProvider,
              public productProvider: ProductProvider,
              public modalService: NgbModal,
              public stockProvider: StockProvider,
              public dateUtil: DateUtil,
              public participantProvider: ParticipantProvider,
              public provider: BelongingsProvider,
              public receiptProvider: ReceiptProvider,
                public adicionarArquivosModalService: NgbModal,
            ) {
  }

  ngOnInit() {
    this.initializeFormConfiguration();
    if (this.exist) {
      this.setLancamentoExistenteForm();
    }
    this.receiptProvider.getReceiptsByCompanyId()
      .then(receipts => {
        this.handleReceipts(receipts)
         this.filteredReceipt = this.receiptCtrl.valueChanges.pipe(
            startWith(''),
            map((fruit: string | null) => fruit ? this._filterR(fruit) : this.allReceipts.slice()));
  })
  /*
      this.receiptCtrl.valueChanges
           .pipe(takeUntil(this._onDestroy))
           .subscribe(() => {
             this.filterReceipt();
           });*/
  }
   private _filterR(value: any): any[] {
    if (typeof value === 'string') {
      const name = value;
      return value ? this.allReceipts.filter(fruit => fruit.description.toLowerCase().includes(name.toLowerCase())) : this.allReceipts;
    }
  }


  handleReceipts(receipts) {
    console.log(receipts)
    this.allReceipts = receipts.map(receipt => ({
      ...receipt,
      formatedDate: moment(receipt.date).locale('pt-BR').format('DD/MM/YYYY')
    }));
    console.log(this.allReceipts)
    this.filteredReceipts = this.allReceipts;
   // if (this.conciliacao) this.changeValues();
   
   //   this.initializeFormArrayFilter(0);
    
  }


removeReceipt(indx): void {
    this.receipts.splice(indx, 1);
  }
    selectedReceipt(event: MatAutocompleteSelectedEvent){
      if(event.option.value!=0){
        let eventInsert;
        if (event.option === undefined) {
          eventInsert = event;
        } else {
          eventInsert = event.option.value;
        }
  
        let exist = false;
        this.receipts.forEach((receipt, index: number) => {
          if (receipt.id === eventInsert.id) {
            exist = true;
            this.snackBar.open('Arquivo já selecionado!', 'atencao');
             this.receiptInput.nativeElement.value = '';
            this.receiptCtrl.setValue(null);
          }
          if (!exist && this.receipts.length === index + 1) {
            this.receipts.push(eventInsert);
            this.receiptInput.nativeElement.value = '';
            this.receiptCtrl.setValue(null);
          }
        });
        if (this.receipts.length === 0) {
          this.receipts.push(eventInsert);
          this.receiptInput.nativeElement.value = '';
          this.receiptCtrl.setValue(null);
        }
      }
    }
  
      openFileModal() {
        let modalOptions: NgbModalOptions = {
          backdrop: 'static',
          windowClass: localStorage.getItem('theme') == 'dark'? 'dark-theme' : ''
        };
        try {
            const modalRef = this.adicionarArquivosModalService.open(AdicionarArquivosComponent, modalOptions);
            modalRef.result.then((result: any) => {
              if (result !== 'Cancelou') {
                this.receiptProvider.getReceiptsByCompanyId().then((receipts: any[]) => {
                  this.allReceipts = receipts;
                  this.allReceipts.forEach((receipt) =>{
                    receipt.formatedDate = moment(receipt.date).locale('pt-BR').format('DD/MM/YYYY')
                  })
                  this.filteredReceipts = this.allReceipts;
                  this.receiptCtrl.setValue('');
                  if(result.lenght != 0){
                    result.forEach((receipt) =>{this.receipts.push(receipt)})
                  }
    
                });
              }
            });
        } catch (error) {
            console.error('', error);
        }
      }
  initializeFormConfiguration() {
    this.allYears = getYears(+moment().format('YYYY') - 20);
    this.allYears.sort((a, b) => b - a);
    this.description = new FormControl('', Validators.required);
    this.code = new FormControl('', Validators.required);
    this.addYear();
    this.years[0].get('year').setValue(+moment().format('YYYY'));
     
  }
 
  getFile(receipt) {
    this.carregando = true;
    this.receiptProvider.downloadFile(receipt.file).then((value: any) => {
      const extension = receipt.file.split('.').pop();
      let blob;
      if(extension == 'pdf' || extension == 'xls' || extension == 'xlsx' || extension == 'doc' || extension == 'docx' || extension == 'txt'){
        let type = 'application/' + extension;
        blob = new Blob([value], {type: type});
      }
      else if(extension == 'png' || extension == 'jpg' || extension == 'jpeg'){
        let type = 'image/' + extension;
        blob = new Blob([value], {type: type});
      }
      else{
        blob = new Blob([value], {type: 'application/octet-stream'});
      }
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      this.carregando = false;
    }).catch((error) => {
      this.snackBar.openLong('Erro ao baixar arquivo', 'error');
    });
  }
  setLancamentoExistenteForm() {
    if (!this.exist) return;

    this.description.setValue(this.exist.description);
    this.code.setValue(this.exist.code);
    this.years = this.exist.years.map((year) => {
      return new FormGroup({
        year: new FormControl(year.year, Validators.required),
        value: new FormControl(year.value, Validators.required)
      });
    });
    if(this.exist.receipts){
      this.receipts = this.exist.receipts;
    }
    if(this.exist.observation){
      this.observation .setValue(this.exist.observation)
    }
  }

  addYear() {
    this.years.push(new FormGroup({
      year: new FormControl('', Validators.required),
      value: new FormControl('', Validators.required)
    }));
  }

  removeYear(i: number) {
    this.years.splice(i, 1);
  }

  hasDuplicateYears(): boolean {
    const years = this.years.map(group => group.get('year').value);
    return new Set(years).size !== years.length;
  }

  submitForm() {
    this.enviando = true;
    this.enviado = true;
    if (this.description.valid && this.code.valid && this.years.every(year => year.valid)) {
      if (this.hasDuplicateYears()) {
        this.enviando = false;
        this.snackBar.open('Não é permitido anos duplicados!', 'error');
        return;
      }
      
      const obj = {
        id: this.edit ? this.exist.id : null,
        companyId: localStorage.getItem('idEmpresa'),
        description: this.description.value,
        code: this.code.value,
        observation: this.observation.value, 
        years: this.years.map(year => ({
          year: year.value.year,
          value: year.value.value
        })),
        receipts: this.receipts
      };
      obj.years = obj.years.sort((a, b) => b.year - a.year);

      (this.edit ? this.provider.put(obj) : this.provider.post(obj)).then(result => {
        this.enviando = false;
        Swal.fire({
          title: 'Sucesso!',
          text: `Bem ${this.edit ? 'editado' : 'cadastrado'} com sucesso.`,
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => this.activeModal.close(result));
      }).catch((result: HttpErrorResponse) => {
        this.enviando = false;
        this.snackBar.open(`Não foi possível ${this.edit ? 'editar' : 'cadastrar'} o bem!`, 'error');
      });
    } else {
      this.enviando = false;
      this.snackBar.openLong('Preencha todos os campos obrigatórios', 'erro');
    }
  }

}

function getYears(startYear) {
  const currentYear = new Date().getFullYear() + 1;
  // tslint:disable-next-line: prefer-const
  let years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    years.push(startYear++);
  }
  return years;
}
